module.exports = __webpack_public_path__ + "media/images/front/icons/info_edit-ab846c013b7e79a11b67be529b64e0c5.png";